// 47225: the ONE global host of a leg's DOCUMENT record (openDocRecord in openSaleRecord.js): a goodwill voucher opens AvoirQuickView (the sheet Customers > Goodwill opens),
// a payment voucher SalesDocumentSheet. Same components as the order page registry (drawerRegistry: goodwill_voucher = avoir, payment_voucher = sheet).
// 47232: a return leg's RETURN (openReturnRecord): the order's returns are read once (GET /sales-orders/:op/returns), the one whose finance_id is the leg is rendered as the SAME
// RecordKindDrawer kind 'return' with the SAME payload (returnDrawerRow) as Sales > Orders > Deliveries > Returned; its Adjustments link opens that order tab.
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '../services/api';
import { AvoirQuickView } from '../components/Sales/avoir/AvoirBits';
import SalesDocumentSheet from '../components/Sales/avoir/SalesDocumentSheet';
import RecordKindDrawer from '../pages/Sales/orderPage/RecordKindDrawer';
import { servedReturnRow, returnDrawerRow } from '../pages/Sales/orderPage/orderPageModel.mjs';
import { OPEN_DOC_RECORD } from './openSaleRecord';

function ReturnRecord({ op, legId, onClose }) {
  const { t } = useTranslation('orderPage');
  const navigate = useNavigate();
  const [cur, setCur] = useState(null);   // { id, row } once read; row.empty = 'returnLoad' when the return could not be read
  useEffect(() => {
    let live = true;
    api.request(`/sales-orders/${encodeURIComponent(op)}/returns`).catch(() => null).then((d) => {
      if (!live) return;
      const hit = d && Array.isArray(d.returns) ? d.returns.find((r) => String(r.finance_id) === legId) : null;
      setCur(hit ? { id: hit.id, row: returnDrawerRow(servedReturnRow(hit), t('deliv.z4')) } : { id: legId, row: { title: t('deliv.z4'), empty: 'returnLoad' } });
    });
    return () => { live = false; };
  }, [op, legId, t]);
  return cur ? <RecordKindDrawer kind="return" id={cur.id} options={{ row: cur.row }} onClose={onClose}
    onLink={(l) => { onClose(); navigate(`/sales/orders/${encodeURIComponent(op)}?tab=${l.key}`); }} /> : null;
}

export default function DocRecordHost() {
  const [q, setQ] = useState(null);
  useEffect(() => {
    const on = (e) => setQ({ ...e.detail, _ts: Date.now() });
    window.addEventListener(OPEN_DOC_RECORD, on);
    return () => window.removeEventListener(OPEN_DOC_RECORD, on);
  }, []);
  if (!q) return null;
  const close = () => setQ(null);
  return q.kind === 'goodwill_voucher' ? <AvoirQuickView key={q._ts} id={q.id} onClose={close} />
    : q.kind === 'payment_voucher' ? <SalesDocumentSheet key={q._ts} kind="payment_voucher" id={q.id} onClose={close} />
    : q.kind === 'return' ? <ReturnRecord key={q._ts} op={q.operation_id} legId={q.id} onClose={close} /> : null;
}
